import { render, staticRenderFns } from "./MiniBar.vue?vue&type=template&id=ebc8c03c&scoped=true&"
import script from "./MiniBar.vue?vue&type=script&lang=js&"
export * from "./MiniBar.vue?vue&type=script&lang=js&"
import style0 from "./MiniBar.vue?vue&type=style&index=0&id=ebc8c03c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc8c03c",
  null
  
)

export default component.exports